import { CheckCircle } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "../Reveal";

const ITEMS = [
    "Healthcare ecosystem conversations",
    "Hospital partnership development",
    "Patient journey validation",
    "Technology architecture",
    "AI product development",
    "International market research",
];

export default function CurrentStage() {
    return (
        <section data-testid="current-stage-section" className="py-28 lg:py-36 bg-tint-slate noise-overlay">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
                    <div className="lg:col-span-5">
                        <SectionHeading
                            chapter="13"
                            eyebrow="Where We Are"
                            title="We're building."
                            description="GoMedVoyage is currently in its early validation and ecosystem-building phase. We believe transparency builds more trust than pretending otherwise."
                            testid="current-stage-heading"
                        />
                    </div>
                    <div className="lg:col-span-7">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            {ITEMS.map((item, i) => (
                                <Reveal key={item} delay={0.06 * i}>
                                    <div
                                        data-testid={`stage-item-${i + 1}`}
                                        className="flex items-center gap-3 rounded-2xl border border-slate-100 bg-white px-6 py-5 shadow-sm hover:border-brand-green/30 transition-colors duration-300"
                                    >
                                        <CheckCircle size={22} weight="fill" className="text-brand-green shrink-0" />
                                        <span className="text-sm font-semibold text-slate-700">{item}</span>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
